import { Box, CircularProgress, Typography } from "@mui/material";

interface LoadingProps {
  message?: string;
  blurBackdrop?: boolean;
}
const Loading = ({
  message = "Loading",
  blurBackdrop = true,
}: LoadingProps) => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.3)",
        backdropFilter: blurBackdrop ? "blur(1px)" : "none",
        WebkitBackdropFilter: blurBackdrop ? "blur(1px)" : "none",
        zIndex: 999,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 220,
          height: 220,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress
          enableTrackSlot
          size={220}
          thickness={1}
          sx={{
            position: "absolute",
            animationDuration: "15s",
          }}
        />
        <Box
          component="img"
          src="/trackexpense192.png"
          alt="Loading"
          sx={{
            width: 160,
            height: 160,
            borderRadius: "50%",
          }}
        ></Box>
      </Box>
      <Typography
        sx={{
          marginTop: 2,
          color: "#9a9a9a",
          fontWeight: "fontWeightBold",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default Loading;
